<template>
  <v-app>
    <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
    <v-card class="grlCardInfo">
      <v-breadcrumbs :items="obtRuta" class="grlClase">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-card>
    <!--IMAGEN Y TITULO DE LA PÁGINA-->
    <v-card>
      <v-img :src="imgTitle" class="grlCardImg">
        <div class="grlCardInfo">
          <h1 class="my-auto hidden-sm-and-down">Ingenierías</h1>
        </div>
      </v-img>
    </v-card>
    <!---->
    <div class="gralMargenes" id="gralEspaciado">
      <span class="title">
        <h2> Oferta Educativa</h2>
      </span>
      <v-row>
        <v-col v-for="ing in ingenierias" :key="ing.id" cols="12" md="4">
          <v-card width="344" class="CardIng mx-auto">
            <v-img contain height="200px" :src="ing.src"></v-img>
            <v-card-title>{{ ing.title }}</v-card-title>
            <v-card-subtitle>ESPECIALIDAD EN: {{ ing.subtitle }}</v-card-subtitle>
            <v-card-actions>
              <v-btn @click="insertarRuta(`${ing.ruta}`)" dark color="red" text>
                DETALLES
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-card class="cardInfoIng mx-auto">
          <v-card-text>
            <div class="text--primary">
              <strong style="font-size: 20px;">INFORMACIÓN.</strong>
              <br>
              <br>
              <p>
                La Facultad de Agricultura y Zootecnia,
                cuenta con tres programas educativos a nivel
                licenciatura de los cuales dos se encuentran
                acreditados por COMEAA.
              </p>
              <hr>
              <h6><a href="/aspirantes/admision">Proceso de Admisión</a></h6>
              <h6><a href="/pdfs/Requisitos.pdf" target="_blank">Requisitos</a></h6>
              <h6><a href="/contacto">Contacto</a></h6>
            </div>
          </v-card-text>
        </v-card>
      </v-row>
    </div>
  </v-app>
</template>
<script>

export default {
  name: 'PagInicio',
  data() {
    return {
      ingenierias: [
        {
          id: 1,
          title: 'INGENIERO AGRÓNOMO',
          subtitle: 'Zootecnista',
          src: require('../../assets/img/zootecnia.jpg'),
          ruta: '/oferta-educativa/zootecnia',
        },
        {
          id: 2,
          title: 'INGENIERO AGRÓNOMO',
          subtitle: 'Fitotecnia',
          src: require('../../assets/img/zootecnia.jpg'),
          ruta: '/oferta-educativa/fitotecnia',
        },
        {
          id: 3,
          title: 'INGENIERO EN FRUTICULTURA',
          subtitle: '',
          src: require('../../assets/img/fitotecnia.jpg'),
          ruta: '/oferta-educativa/fruticultura',
        },
      ],
      imgTitle: require('../../assets/img/banner-OE.jpg'),
      obtRuta: [
        {
          text: 'Inicio',
          disabled: false,
          ruta: '/',
        },
        {
          text: 'Oferta Educativa',
          disabled: true,
          ruta: '/',
        },
        {
          text: 'Licenciaturas',
          disabled: true,
          ruta: '/',
        },
      ],
    };
  },
  methods: {
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
  },
};
</script>
